const $ = jQuery.noConflict();

class LoadMorePosts {
    constructor(loadMore, section, funcName) {
        this.loadMore = loadMore;
        this.section = section;
        this.funcName = funcName;
        this.offset = $(this.section).data('offset') * 1;
        this.currentOffset = this.offset;
    }
    init() {
        this.bindEvents();
        this.hideLoadMore();
        this.runAjaxOnLoad();

    }
    runAjaxOnLoad(e) {
        const section = $(this.section);
        const currentTaxonomy = $(section).data('filter');
        const classes = $(section).data('class');
        const taxType = $(section).data('taxonomy');
        const postType = $(section).data('post-type');
        const url = window.location.href;
        const query = url.split('?')[1];
        if (query) {
            const offset = Number(query.split('posts=')[1]);
            this.loadMoreAjax(this.currentOffset, offset, currentTaxonomy, classes, this.funcName, taxType, postType, 'load');
            this.currentOffset = this.currentOffset + offset;
        }
    }
    bindEvents() {
        $(this.loadMore).on('click', (e) => this.loadMorePosts(e));
    }
    hideLoadMore() {
        const numOfArticles = $(this.section).data('post-num');

        if (numOfArticles <= this.offset) {
            $(this.loadMore).hide();
        }

    }
    loadMorePosts(e) {
        const section = $(e.currentTarget).closest('section');
        const currentTaxonomy = $(section).data('filter');
        const classes = $(section).data('class');
        const taxType = $(section).data('taxonomy');
        const postType = $(section).data('post-type');

        this.loadMoreAjax(this.currentOffset, this.offset, currentTaxonomy, classes, this.funcName, taxType, postType, e.type);
        this.currentOffset = this.currentOffset + this.offset;
    }
    loadMoreAjax(currentOffset, offset, currentTaxonomy, classes, funcName, taxonomy, postType, eventType) {
        const section = $(this.section);
        const row = section.find('.row');
        const ajaxUrl = WP.ajaxUrl;
        let allowAjax = true;
        const loadMoreBtn = $(this.loadMore);
        const imgLoader = '<img src="' + WP.templateUrl + '/images/gifs/loading.gif" alt="loading" class="loader"/>';

        if (allowAjax) {
            allowAjax = false;
            $(imgLoader).insertAfter(row);
            var formData = new FormData();
            formData.append('action', funcName);
            formData.append('num', offset);
            formData.append('curnum', currentOffset);
            formData.append('classes', classes);
            formData.append('taxonomy', taxonomy);
            formData.append('postType', postType);

            if (currentTaxonomy !== "") {
                formData.append('taxonomy_name', currentTaxonomy);
            }
            const that = this;

            $.ajax({
                type: 'POST',
                url: ajaxUrl,
                contentType: false,
                processData: false,
                data: formData,
                dataType: 'json',
                success: function (response) {
                    allowAjax = true;
                    $(".loader").detach();

                    if (response) {
                        if (typeof response === 'object') {

                            if (response.html.length > 0) {

                                const $items = $(response.html);
                                row.append($items);
                                const currNoOfPost = section.find('article').length;
                                const overallNoOfPost = section.data('post-num');

                                if (currNoOfPost < overallNoOfPost) {
                                    loadMoreBtn.show();
                                }
                                else {
                                    loadMoreBtn.hide();
                                }
                            }

                            if (eventType === "click") {
                                if (response.postsNo) {
                                    window.history.pushState("posts", "", window.location.href.split('?')[0] + "?posts=" + response.postsNo)
                                }
                            }
                        }
                    }
                }
            });
        }
    }
}


const loadPostsBlog = new LoadMorePosts('.blog-posts .load-more', '.blog-posts', 'load_more');
const loadPostsCl = new LoadMorePosts('.cl-posts .load-more', '.cl-posts', 'load_more_cl');

export default loadPostsBlog;
export {
    loadPostsCl
}